// this component is resposible for creating top bar(which includes search, filter, sort, upload, download and reset)
// this component also contain logic of pagination
import React, { useEffect, useState } from "react";
import AppointmentHistoryList from "./AppointmentHistoryList";
import ViewDetailsModal from "../DoctorDashboard/modal-view-details";
import DocumentDoctor from "../DocumentDoctor";
import Drawer from "@material-ui/core/Drawer";
import PrescriptionComponent from "../DoctorVideo/PrescriptionComponent";
import Select, { components } from "react-select";
import { Dropdown } from "react-bootstrap";
import moment from "moment";
import searchIcon from "../../assets/forhomepage/search_icon.svg";
import closeIcon from "../../assets/forhomepage/close_icon.svg";
import FilterIcon from "../../assets/FliterIcon.svg";
import Filter from "../../assets/Filter.svg";
import FilterModal from "./FilterModal";
import Pagination from "../common/Pagination/Pagination";
import * as Constant from "./constants";
import ViewDetailsModalNew from "../DoctorDashboard/modal-view-details-new";
import Download from "../../assets/download-icon.svg";
import { CSVLink, CSVDownload } from "react-csv";
import { withStyles } from "@material-ui/core/styles";
import Tooltip from "@material-ui/core/Tooltip";
import afterLoginApi from "../../Util/API Calls/afterLogin";
import AppointmentSummary from "./AppointmentSummary";
import Loader from "../UI Component/Loader/Loader";
import DisabledDownload from "../../assets/Group 25467.svg";
import DownloadReport from "../../components/DownloadReport/DownloadReport";
import { useHistory } from "react-router-dom";
import { LOCALSTORAGEKEY } from "../../Util/Helper/localStorageUtils";
import { C2CConsole } from "../../Util/Helper/C2CConsole";

function useDebounce(value, delay) {
  const [debouncedValue, setDebouncedValue] = useState(value);
  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);
    return () => {
      clearTimeout(handler);
    };
  }, [value, delay]);
  return debouncedValue;
}
const TextOnlyTooltip = withStyles({
  tooltip: {
    bottom: "2px",
    color: "#1B2027",
    backgroundColor: "white",
    fontSize: "12px",
    boxShadow: "rgba(0, 0, 0, 0.35) 0px 5px 15px",
  },
})(Tooltip);
const AppointmentHistoryLayout = (props) => {
  const [activeIndex, setActiveIndex] = useState(1);
  const [openView, setOpenView] = useState(false);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [appointment_id, setAppointment_id] = useState(null);
  const [mobileFilter, setMobileFilter] = useState(false);
  const [inputText, setInputText] = useState("");
  const [selectedStartDate, setStartDate] = useState("");
  const [selectedEndDate, setEndDate] = useState("");
  // modification logic here =>
  const debouncedSearchTerm = useDebounce(inputText, 500);
  const [appointment_status, setappointment_status] = useState(null);
  let PageSize = 10;
  const [onlyDoctorName, setDoctorName] = useState("all");
  const [currentPage, setCurrentPage] = useState(props.pageNo || 1);
  const [dateStatus, setDateStatus] = useState("");
  const [allDoctorsRelatedData, setAllDoctorsRelatedData] = useState(
    props.temp_doctor_selected
  );
  const [loading, setLoading] = useState(false);

  let is_staff = localStorage.getItem("user_type");
  const userId = localStorage.getItem(LOCALSTORAGEKEY.USER_ID);
  const staffId = localStorage.getItem(LOCALSTORAGEKEY.STAFF_ID);

  let staffDoctorPayload;
  is_staff === "staff"
    ? (staffDoctorPayload = {
        doctor_id: props.temp_doctor_selected,
        staff_id: staffId,
      })
    : (staffDoctorPayload = {
        doctor_id: userId,
      });
  let appointmentStartDate = localStorage.getItem("appointmentStartDate")
    ? moment(localStorage.getItem("appointmentStartDate")).format("YYYY-MM-DD")
    : "";

  let appointmentEndDate = localStorage.getItem("appointmentEndDate")
    ? moment(localStorage.getItem("appointmentEndDate")).format("YYYY-MM-DD")
    : "";

  let appointmentCheckInStartDate = localStorage.getItem(
    "appointmentCheckInStartDate"
  )
    ? moment(localStorage.getItem("appointmentCheckInStartDate")).format(
        "YYYY-MM-DD"
      )
    : "";

  let appointmentCheckInEndDate = localStorage.getItem(
    "appointmentCheckInEndDate"
  )
    ? moment(localStorage.getItem("appointmentCheckInEndDate")).format(
        "YYYY-MM-DD"
      )
    : "";

  const [activeDropDown, setActiveDropDown] = useState("most_recent_first");
  const [activePrescriptionDropDown, setActivePrescriptionDropDown] =
    useState("all");
  const [appointmentDropDown, setAppointmentDropDown] = useState({
    value: "all",
    label: "All",
  });
  const [showFilterComponent, setShowFilterComponent] = useState(false);
  // const [allDoctorsRelatedData, setAllDoctorsRelatedData] = useState("all");
  const [status, setStatus] = useState("all");
  const [appointmentStatusData, setAppointmentStatusData] = useState("all");
  const [prescriptionStatus, setPrescriptionStatus] = useState("all");

  const [mobileFilterData, setMobileFilterData] = useState(null);
  const [resetMobileFilter, setResetMobileFilter] = useState(false);
  const [exportMyappointmentData, setExportMyappointmentData] = useState([]);
  const downloadRef = React.useRef();
  const [disableDownload, setDisableDownload] = useState(false);
  const [downloadReport, setDownloadReport] = useState([]);
  const [csvData, setCsvData] = useState([
    [
      "Date & Time",
      "Patient Name",
      "Mobile No.",
      "Consultation",
      "Appointment Status",
      "Patient Gender",
      "Patient DOB",
      "Patient's Purpose of Consult",
      "Payment Method",
    ],
  ]);
  let appointmentConsultationFilter = JSON.parse(
    localStorage.getItem("appointmentConsultationFilter")
  );
  let appointmentStatusFilter = JSON.parse(
    localStorage.getItem("appointmentStatusFilter")
  );
  let appointmentSortFilter = localStorage.getItem("appointmentSortFilter");
  const defaultSetUp = {
    // show_upcoming: false,
    search_string: "",
    sort_order: appointmentSortFilter ? appointmentSortFilter : "all",
    status_filter: "all",
    appointment_filter: appointmentStatusFilter
      ? appointmentStatusFilter.value
      : "all",
    consultation_filter:
      appointmentConsultationFilter &&
      appointmentConsultationFilter.type == "consultation"
        ? appointmentConsultationFilter.value
          ? appointmentConsultationFilter.value
          : "all"
        : "",
    rows_per_page: 10,
    // page_no: 1,
    start_date: appointmentStartDate ? appointmentStartDate : "",
    end_date: appointmentEndDate ? appointmentEndDate : "",
    mark_check_in_start_date: appointmentCheckInStartDate
      ? appointmentCheckInStartDate
      : "",
    mark_check_in_end_date: appointmentCheckInEndDate
      ? appointmentCheckInEndDate
      : "",
    ...staffDoctorPayload,
    procedure_type_filter:
      appointmentConsultationFilter &&
      appointmentConsultationFilter.type == "procedure"
        ? appointmentConsultationFilter.value
        : "",
  };
  const dropdownOptions = [
    { value: "all", label: "All", doctor_id: props.doctor_selected },
    {
      value: "upcoming",
      label: "Upcoming Appointments",
      doctor_id: props.doctor_selected,
    },
    {
      value: "past",
      label: "Past Appointments",
      doctor_id: props.doctor_selected,
    },
  ];
  const [term, setTerm] = useState(defaultSetUp);
  // const [staffDoctorPayloads, setStaffDoctorPayloads] = useState("")
  const csvRef = React.useRef();
  let history = useHistory();
  useEffect(
    () => {
      if (props?.pageNo) {
        setCurrentPage(props.pageNo);
      }
    },
    [props.pageNo] // Only call effect if page changes
  );
  useEffect(() => {
    setActiveDropDown(
      appointmentSortFilter ? appointmentSortFilter : "most_recent_first"
    );
  }, [appointmentSortFilter]);
  useEffect(
    () => {
      if (debouncedSearchTerm && debouncedSearchTerm.length) {
        onFilterSubmit({ search_string: debouncedSearchTerm });
      } else {
        onFilterSubmit({ search_string: "" });
      }
    },
    [debouncedSearchTerm] // Only call effect if debounced search term changes
  );
  useEffect(() => {
    if (exportMyappointmentData && exportMyappointmentData?.length > 0) {
      setTimeout(() => {
        csvRef.current.link.click();
      }, 500);
    }
  }, [exportMyappointmentData]);

  const handleDisableDownload = () => {
    setDisableDownload(false);
  };

  const onClickExportCsv = () => {
    setLoading(true);
    let defaultFilters = getDefaultFilters();
    let tempTerm = defaultFilters;
    let docName = JSON.parse(localStorage.getItem("appointmentDoctorName"));
    let ids = null;
    if (docName) {
      ids = Array.isArray(docName.doctor_id)
        ? docName.doctor_id
        : [docName.doctor_id];
    } else {
      ids =
        props.temp_doctor_selected?.length > 0
          ? props.temp_doctor_selected
          : [userId];
    }
    if (is_staff === "staff") {
      tempTerm["doctor_id"] = ids;
    } else {
      tempTerm["doctor_id"] = userId;
    }

    afterLoginApi
      .post(
        `/download-report`,
        {
          report_type: "appointment",
          user_type: localStorage.getItem("user_type"),
          payload: {
            ...tempTerm,
            download: true,
          },
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: localStorage.getItem("id_token"),
          },
        }
      )
      .then((res) => {
        if (res && res.data.message === "request published successfully") {
          downloadRef.current.showDownloadReport();
          localStorage.setItem("DownloadReport", "true");
          localStorage.setItem("AppntDisableDownload", "true");
          setDisableDownload(true);
          let arr = [];
          arr = localStorage.getItem("DownloadReportArr")
            ? JSON.parse(localStorage.getItem("DownloadReportArr"))
            : [];
          arr.push({
            id: res.data.request_id,
            filename: res.data.filename,
            requestType: "appointment",
            pause: false,
          });
          localStorage.setItem("DownloadReportArr", JSON.stringify(arr));
          setDownloadReport(arr);
        }
        setLoading(false);
      })
      .catch((err) => {
        C2CConsole.log(err);
      });
  };
  function renderConsultationType(
    appointmentType,
    consultationType,
    procedureName,
    allAppointmentProcedures
  ) {
    let appointmentTypeText =
      appointmentType === "in-clinic" ? "In-Clinic" : "Tele-Consult";
    switch (appointmentType) {
      case "online":
        if (consultationType === "instant") {
          return "Instant";
        }
        if (consultationType === "followup") {
          return appointmentTypeText + " Follow-Up";
        }
        return appointmentTypeText + " Regular";
      case "regular":
        return appointmentTypeText + " Regular";
      case "followup":
        return appointmentTypeText + " Follow-Up";
      case "procedure":
        return procedureName;
      case "in-clinic":
        if (consultationType === "procedure") {
          return allAppointmentProcedures !== ""
            ? allAppointmentProcedures
            : procedureName;
        }
        return allAppointmentProcedures !== ""
          ? allAppointmentProcedures
          : appointmentTypeText + " Consultation"; // fix for 7043
      default:
        return "";
    }
  }
  // function renderConsultationType(
  //   appointmentType,
  //   consultationType,
  //   procedureName
  // ) {
  //   let appointmentTypeText =
  //     appointmentType === "in-clinic" ? "In-Clinic" : "Tele-Consult";
  //   switch (appointmentType) {
  //     case "online":
  //       if (consultationType === "instant") {
  //         return "Instant";
  //       }
  //       if (consultationType === "followup") {
  //         return `${appointmentTypeText + " Follow-Up"}`;
  //       }
  //       return `${appointmentTypeText + " Regular"}`;
  //     case "regular":
  //       return `${appointmentTypeText + " Regular"}`;
  //     case "followup":
  //       return `${appointmentTypeText + " Follow-Up"}`;
  //     case "procedure":
  //       return `${procedureName}`;
  //     case "in-clinic":
  //       if (consultationType === "procedure") {
  //         return `${procedureName}`;
  //       }
  //       return `${appointmentTypeText + " Consultation"}`;
  //     case "instant":
  //       return `Instant`;
  //     default:
  //       return "";
  //   }
  // }

  useEffect(() => {
    if (
      localStorage.getItem("AppntDisableDownload") &&
      localStorage.getItem("AppntDisableDownload") === "true"
    ) {
      setDisableDownload(true);
    } else {
      setDisableDownload(false);
    }
  }, []);

  useEffect(() => {
    setDateStatus(Constant.dateRange(selectedStartDate, selectedEndDate));
    if (localStorage.getItem("appointment_status_filter")) {
      let index = dropdownOptions.findIndex(
        (dr) => dr.value === localStorage.getItem("appointment_status_filter")
      );
      setAppointmentDropDown(dropdownOptions[index]);
    }
    if (localStorage.getItem("appointmentPrescriptionFilter")) {
      setPrescriptionStatus(
        localStorage.getItem("appointmentPrescriptionFilter")
      );
      setActivePrescriptionDropDown(
        localStorage.getItem("appointmentPrescriptionFilter")
      );
    }
  }, []);

  useEffect(() => {
    setDateStatus(Constant.dateRange(selectedStartDate, selectedEndDate));
  }, [
    appointmentStatusData,
    status,
    selectedStartDate,
    selectedEndDate,
    prescriptionStatus,
    allDoctorsRelatedData,
  ]);

  // Helper methods ==>

  const getDefaultFilters = () => {
    let startDate = localStorage.getItem("appointmentStartDate")
      ? moment(localStorage.getItem("appointmentStartDate")).format(
          "YYYY-MM-DD"
        )
      : "";

    let endDate = localStorage.getItem("appointmentEndDate")
      ? moment(localStorage.getItem("appointmentEndDate")).format("YYYY-MM-DD")
      : "";

    let checkInStartDate = localStorage.getItem("appointmentCheckInStartDate")
      ? moment(localStorage.getItem("appointmentCheckInStartDate")).format(
          "YYYY-MM-DD"
        )
      : "";

    let checkInEndDate = localStorage.getItem("appointmentCheckInEndDate")
      ? moment(localStorage.getItem("appointmentCheckInEndDate")).format(
          "YYYY-MM-DD"
        )
      : "";
    let sortingFilter = localStorage.getItem("appointmentSortingFilter");
    let status_filter = localStorage.getItem("appointment_status_filter");
    let consultationFilter = JSON.parse(
      localStorage.getItem("appointmentConsultationFilter")
    );
    let statusFilter = JSON.parse(
      localStorage.getItem("appointmentStatusFilter")
    );
    let consultationVal = "";
    if (consultationFilter && consultationFilter.type == "consultation") {
      consultationVal = consultationFilter.value
        ? consultationFilter.value
        : "all";
    }
    const defaultData = {
      search_string: inputText,
      sort_order: sortingFilter ? sortingFilter : "all",
      status_filter: status_filter ? status_filter : "all",
      appointment_filter: statusFilter ? statusFilter.value : "all",
      consultation_filter: consultationVal,
      rows_per_page: 10,
      start_date: startDate ? startDate : "",
      end_date: endDate ? endDate : "",
      mark_check_in_start_date: checkInStartDate ? checkInStartDate : "",
      mark_check_in_end_date: checkInEndDate ? checkInEndDate : "",
      ...staffDoctorPayload,
      procedure_type_filter:
        consultationFilter && consultationFilter.type == "procedure"
          ? consultationFilter.value
          : "",
    };
    setTerm(defaultData);
    return defaultData;
  };

  // <==

  const onFilterSubmit = (event) => {
    let defaultFilters = getDefaultFilters();
    let tempTerm = defaultFilters;
    if ("show_upcoming" in event) {
      tempTerm["show_upcoming"] = event["show_upcoming"];
    }
    if ("search_string" in event) {
      tempTerm["search_string"] = event["search_string"].trim();
    }
    if ("sort_order" in event) {
      tempTerm["sort_order"] = event["sort_order"];
      localStorage.setItem("appointmentSortFilter", event["sort_order"]);
    }
    if ("page_no" in event) {
      tempTerm["page_no"] = event["page_no"];
      setActiveIndex(event["page_no"]);
      setCurrentPage(event["page_no"]);
    }
    if ("doctor_id" in event) {
      tempTerm["doctor_id"] = event["doctor_id"];
    } else {
      tempTerm["doctor_id"] =
        props?.temp_doctor_selected?.length > 0
          ? props?.temp_doctor_selected
          : userId;
    }
    if ("status_filter" in event) {
      tempTerm["status_filter"] = event["status_filter"];
    }
    if ("appointment_filter" in event) {
      tempTerm["appointment_filter"] = event["appointment_filter"];
    }
    if ("consultation_filter" in event) {
      tempTerm["consultation_filter"] = event["consultation_filter"];
    }
    if ("prescription_filter" in event) {
      tempTerm["prescription_filter"] = event["prescription_filter"];
    }
    if ("procedure_type_filter" in event) {
      tempTerm["procedure_type_filter"] = event["procedure_type_filter"];
    }
    setTerm(tempTerm);
    props.onSubmit(tempTerm);
  };

  const onSubmit = (event) => {
    term["page_no"] = 1;
    if (is_staff === "staff") {
      term["doctor_id"] = props.temp_doctor_selected;
    } else {
      term["doctor_id"] = userId;
    }
    setActiveIndex(1);
    setCurrentPage(1);
    setInputText(event["search_string"]);
  };

  const resetClick = (event) => {
    let defaultFilters = getDefaultFilters();
    let tempTerm = defaultFilters;
    setMobileFilterData(null);
    setStartDate("");
    setEndDate("");
    setStatus("all");
    setPrescriptionStatus("all");
    setAppointmentStatusData("all");
    setAllDoctorsRelatedData(props.temp_doctor_selected);
    setActivePrescriptionDropDown("all");
    setDoctorName("all");
    if ("prescription_notification_sent" in tempTerm) {
      delete tempTerm["prescription_notification_sent"];
    }
    if (tempTerm["mark_check_in_start_date"]) {
      delete tempTerm["mark_check_in_start_date"];
      delete tempTerm["mark_check_in_end_date"];
    }
    if (tempTerm["start_date"]) {
      delete tempTerm["start_date"];
      delete tempTerm["end_date"];
    }
    if ("search_string" in event) {
      tempTerm["search_string"] = "";
    }
    delete tempTerm["prescription_filter"];
    if ("doctor_id" in event) {
      tempTerm["doctor_id"] =
        is_staff === "staff" ? props.doctor_selected : userId;
    }
    if ("status_filter" in event) {
      tempTerm["status_filter"] = "all";
    }
    if ("appointment_filter" in event) {
      tempTerm["appointment_filter"] = "all";
    }
    if ("consultation_filter" in event) {
      tempTerm["consultation_filter"] = "all";
    }
    if ("procedure_type_filter" in event) {
      tempTerm["procedure_type_filter"] = "";
    }
    setInputText("");
    setTerm(tempTerm);
    tempTerm["page_no"] = 1;

    setActiveIndex(1);
    setCurrentPage(1);
    props.onSubmit(tempTerm);
  };

  const prescriptionFilter = ({ prescription_filter }) => {
    let defaultFilters = getDefaultFilters();
    let tempTerm = defaultFilters;
    if (prescription_filter != "") {
      tempTerm["prescription_filter"] = prescription_filter;
    } else {
      setPrescriptionStatus("all");
      delete tempTerm["prescription_filter"];
    }
    setTerm(tempTerm);
    tempTerm["page_no"] = 1;
    setActiveIndex(1);
    setCurrentPage(1);
    localStorage.setItem("appointmentPrescriptionFilter", prescription_filter);
    props.onSubmit(tempTerm);
  };

  const viewAppointment = (appointment_id, appointment_status) => {
    setAppointment_id(appointment_id);
    setappointment_status(appointment_status);
    setOpenView(true);
  };

  const fetchPastAppointment = () => {
    term["search_string"] = "";
    term["sort_order"] = "most_recent_first";
    term["doctor_id"] = is_staff === "staff" ? allDoctorsRelatedData : userId;
    term["appointment_filter"] = "all";
    term["status_filter"] = "all";
    term["consultation_filter"] = "all";
    term["page_no"] = 1;
    term["rows_per_page"] = 10;
    term["procedure_type_filter"] = "";
    setCurrentPage(1);
    props.fetchPastAppointmentDataList(term);
    setAppointmentDropDown({
      value: "all",
      label: "All",
    });
    setActiveDropDown("most_recent_first");
    setActivePrescriptionDropDown("all");
  };
  const closeView = () => {
    setOpenView(false);
  };

  const doctorsRelatedDataStatus = (event) => {
    if (event === "") {
      term["doctor_id"] = props.doctor_selected;
      term["page_no"] = 1;
      setAllDoctorsRelatedData(event);
      setActiveIndex(1);
      setCurrentPage(1);
      onFilterSubmit(term);
    } else {
      term["page_no"] = 1;
      setActiveIndex(1);
      // setCurrentPage(1);
      onFilterSubmit({ doctor_id: event.doctor_id });
    }
    // setAllDoctorsRelatedData(event)
  };

  const consultationStatus = (event) => {
    if (event === "") {
      term["consultation_filter"] = "all";
      if (is_staff === "staff") {
        term["doctor_id"] = props.temp_doctor_selected;
      } else {
        term["doctor_id"] = userId;
      }
      term["page_no"] = 1;
      setStatus("all");
      setActiveIndex(1);
      setCurrentPage(1);
      onFilterSubmit(term);
    } else {
      if (is_staff === "staff") {
        term["doctor_id"] = event.doctor_id;
      } else {
        term["doctor_id"] = userId;
      }
      term["page_no"] = 1;
      setActiveIndex(1);
      setCurrentPage(1);
      if (is_staff === "staff") {
        onFilterSubmit({
          consultation_filter: event.type == "consultation" ? event.value : "",
          doctor_id:
            props?.temp_doctor_selected?.length === 0
              ? userId
              : props.temp_doctor_selected,
          start_date: appointmentStartDate ? appointmentStartDate : "",
          end_date: appointmentEndDate ? appointmentEndDate : "",
          mark_check_in_start_date: appointmentCheckInStartDate
            ? appointmentCheckInStartDate
            : "",
          mark_check_in_end_date: appointmentCheckInEndDate
            ? appointmentCheckInEndDate
            : "",
          page_no: 1,
          procedure_type_filter: event.type == "procedure" ? event.value : "",
        });
      } else {
        onFilterSubmit({
          consultation_filter: event.type == "consultation" ? event.value : "",
          doctor_id: userId,
          start_date: appointmentStartDate ? appointmentStartDate : "",
          end_date: appointmentEndDate ? appointmentEndDate : "",
          mark_check_in_start_date: appointmentCheckInStartDate
            ? appointmentCheckInStartDate
            : "",
          mark_check_in_end_date: appointmentCheckInEndDate
            ? appointmentCheckInEndDate
            : "",
          page_no: 1,
          procedure_type_filter: event.type == "procedure" ? event.value : "",
        });
      }
    }
  };

  const appointmentStatus = (event) => {
    if (event === "") {
      if (is_staff === "staff") {
        term["doctor_id"] = props.temp_doctor_selected;
      } else {
        term["doctor_id"] = userId;
      }

      term["appointment_filter"] = "all";
      setAppointmentStatusData("all");
      onFilterSubmit(term);
      term["page_no"] = 1;
      setActiveIndex(1);
      setCurrentPage(1);
    } else {
      if (is_staff === "staff") {
        term["doctor_id"] = event.doctor_id;
      } else {
        term["doctor_id"] = userId;
      }
      term["page_no"] = 1;
      setActiveIndex(1);
      setCurrentPage(1);
      if (is_staff === "staff") {
        onFilterSubmit({
          appointment_filter: event.value,
          doctor_id: event.doctor_id,
          start_date: appointmentStartDate ? appointmentStartDate : "",
          end_date: appointmentEndDate ? appointmentEndDate : "",
          mark_check_in_start_date: appointmentCheckInStartDate
            ? appointmentCheckInStartDate
            : "",
          mark_check_in_end_date: appointmentCheckInEndDate
            ? appointmentCheckInEndDate
            : "",
          page_no: 1,
        });
      } else {
        onFilterSubmit({
          appointment_filter: event.value,
          doctor_id: userId,
          start_date: appointmentStartDate ? appointmentStartDate : "",
          end_date: appointmentEndDate ? appointmentEndDate : "",
          mark_check_in_start_date: appointmentCheckInStartDate
            ? appointmentCheckInStartDate
            : "",
          mark_check_in_end_date: appointmentCheckInEndDate
            ? appointmentCheckInEndDate
            : "",
          page_no: 1,
        });
      }
    }
  };
  const fetchCurrentFilterDates = (startDate, endDate) => {
    let appointmentStartDate = localStorage.getItem("appointmentStartDate");

    let appointmentEndDate = localStorage.getItem("appointmentEndDate");
    if (startDate === "") {
      delete term["start_date"];
      delete term["end_date"];
      localStorage.removeItem("appointmentStartDate");
      localStorage.removeItem("appointmentEndDate");
      setStartDate("");
      setEndDate("");
    } else {
      term["start_date"] = moment(appointmentStartDate).format("YYYY-MM-DD");
      term["end_date"] = moment(appointmentEndDate).format("YYYY-MM-DD");
      term["page_no"] = 1;
    }
    setActiveIndex(1);
    setCurrentPage(1);
    setTerm(term);
    props.onSubmit(term);
  };

  const fetchCurrentFilterMarkCheckInDates = (startDate, endDate) => {
    let appointmentCheckInStartDate = localStorage.getItem(
      "appointmentCheckInStartDate"
    );

    let appointmentCheckInEndDate = localStorage.getItem(
      "appointmentCheckInEndDate"
    );
    if (startDate === "") {
      delete term["mark_check_in_start_date"];
      delete term["mark_check_in_end_date"];
      localStorage.removeItem("appointmentCheckInStartDate");
      localStorage.removeItem("appointmentCheckInEndDate");
    } else {
      term["mark_check_in_start_date"] = moment(
        appointmentCheckInStartDate
      ).format("YYYY-MM-DD");
      term["mark_check_in_end_date"] = moment(appointmentCheckInEndDate).format(
        "YYYY-MM-DD"
      );
      term["page_no"] = 1;
    }
    setActiveIndex(1);
    setCurrentPage(1);
    setTerm(term);
    props.onSubmit(term);
  };

  const handleOnChange = (option) => {
    localStorage.setItem("appointment_status_filter", option.value);
    setAppointmentDropDown(option);
    term["page_no"] = 1;
    setActiveIndex(1);
    setCurrentPage(1);
    if (is_staff === "staff") {
      onFilterSubmit({
        status_filter: option.value,
        doctor_id: option.doctor_id,
      });
    } else {
      onFilterSubmit({
        status_filter: option.value,
        doctor_id: userId,
      });
    }
  };

  const DropdownIndicator = (props) => {
    return (
      components.DropdownIndicator && (
        <components.DropdownIndicator {...props}>
          {/*<FontAwesomeIcon icon={props.selectProps.menuIsOpen ? "caret-up" : "caret-down"}/>*/}
          {props.selectProps.menuIsOpen ? (
            <i className="fa fa-caret-up" style={{ color: "#17bae0" }}></i>
          ) : (
            <i className="fa fa-caret-down" style={{ color: "#17bae0" }}></i>
          )}
        </components.DropdownIndicator>
      )
    );
  };

  const clearData = () => {
    setInputText("");
    term["page_no"] = 1;
    setActiveIndex(1);
    setCurrentPage(1);
    onFilterSubmit({ search_string: "" });
  };

  function onFilterSuccess({
    allDoctorsRelatedData,
    appointmentStatus,
    status,
    prescriptionStatus,
    startDate,
    endDate,
    allFilters,
    resetValues,
    doctor_id,
    doctorName,
  }) {
    props.setTempDoctorSelected(doctor_id);
    setMobileFilterData(allFilters);
    setResetMobileFilter(resetValues);
    setShowFilterComponent(false);
    setMobileFilter(true);
    setAllDoctorsRelatedData(props.temp_doctor_selected);
    setAppointmentStatusData(appointmentStatus);
    setStatus(status);
    setPrescriptionStatus(prescriptionStatus);
    setStartDate(moment(startDate).format("YYYY-MM-DD"));
    setEndDate(moment(endDate).format("YYYY-MM-DD"));
    setDoctorName(doctorName);
    if (startDate !== "" && startDate !== null) {
      term["start_date"] = moment(startDate).format("YYYY-MM-DD");
      term["end_date"] = moment(endDate).format("YYYY-MM-DD");
    } else {
      delete term["start_date"];
      delete term["end_date"];
      setStartDate("");
      setEndDate("");
    }

    if (is_staff === "staff") {
      term["doctor_id"] = doctor_id;
    } else {
      term["doctor_id"] = userId;
    }
    if (appointmentStatus !== "") {
      term["appointment_filter"] = appointmentStatus;
    } else {
      term["appointment_filter"] = "all";
    }
    if (status !== "") {
      if (status.type == "consultation") {
        term["consultation_filter"] = status.value;
      } else if (status.type == "procedure") {
        term["procedure_type_filter"] = status.value;
      }
    } else {
      term["consultation_filter"] = "all";
      term["procedure_type_filter"] = "";
    }
    if (prescriptionStatus !== "") {
      term["prescription_filter"] = prescriptionStatus;
    } else {
      term["prescription_filter"] = "all";
    }
    term["page_no"] = 1;
    setActiveIndex(1);
    setCurrentPage(1);
    onFilterSubmit(term);
  }

  return (
    <>
      {loading ? <Loader /> : null}
      <div>
        <DownloadReport
          ref={downloadRef}
          handleAppntDisableDownload={handleDisableDownload}
          downloadReport={downloadReport}
        />
      </div>
      <div
        className={`row mt-4 mx-0 d-none d-sm-none d-lg-flex d-xl-flex px-3 justify-content-between`}
      >
        {/* <div className="col-lg-7 col-md-4 col-12 consult-select">
          <Select
            options={dropdownOptions}
            onChange={handleOnChange}
            defaultValue={appointmentDropDown}
            value={appointmentDropDown}
            components={{DropdownIndicator}}
          />
        </div> */}
        {/* <div> */}
        {/* {is_staff === "staff" ? (
            ""
          ) : ( */}
        <AppointmentSummary
          upcomingAppointmentCount={props.upcomingAppointmentCount}
          totalRecords={props.totalRecords}
        />
        {/* )} */}
        {/* </div> */}
        <div
          className="col-lg-5 col-md-8 row justify-content-lg-end align-items-center"
          style={{ padding: "0px" }}
        >
          <div className="mr-2 search-wrapper">
            <div className="input-holder">
              <input
                type="text"
                className="search-input"
                onChange={(e) => onSubmit({ search_string: e.target.value })}
                value={inputText}
                placeholder="Search by patient name or mobile number."
              />{" "}
              <div className="search-icon">
                <img src={searchIcon} />
              </div>
              {inputText !== "" && (
                <div className="close_serch">
                  <img src={closeIcon} onClick={clearData} />
                </div>
              )}
            </div>
          </div>
          <div className="ml-auto mr-2">
            <Dropdown className="filter-border">
              <Dropdown.Toggle
                style={{
                  background: "transparent",
                  border: "none",
                  margin: "0px",
                  // padding: "0px",
                  fontSize: "19px",
                  color: "#fff",
                  borderColor: "#D6DAE5",
                  backgroundColor: "#fff",
                }}
              >
                {/* <i className="fa fa-filter" aria-hidden="true"></i> */}
                <img src={FilterIcon} />
              </Dropdown.Toggle>

              <Dropdown.Menu className="m-0">
                <Dropdown.Item
                  onClick={() => {
                    setActiveDropDown("most_recent_first");
                    onFilterSubmit({
                      sort_order: "most_recent_first",
                      page_no: 1,
                    });
                  }}
                  style={{
                    fontSize: "13px",
                    padding: "10px 15px",
                    borderBottom: "1px solid #0000001A",
                  }}
                >
                  <i
                    className={`fa fa-check mr-3 check-icon-filter ${
                      activeDropDown === "most_recent_first" ? "activeTab" : ""
                    }`}
                    aria-hidden="true"
                  ></i>
                  Most Recent First
                </Dropdown.Item>

                <Dropdown.Item
                  style={{
                    fontSize: "13px",
                    padding: "10px 15px",
                    borderBottom: "1px solid #0000001A",
                  }}
                  onClick={() => {
                    setActiveDropDown("least_recent_first");
                    onFilterSubmit({
                      sort_order: "least_recent_first",
                      page_no: 1,
                    });
                  }}
                >
                  <i
                    className={`fa fa-check mr-3 check-icon-filter ${
                      activeDropDown === "least_recent_first" ? "activeTab" : ""
                    }`}
                  ></i>
                  Least Recent First
                </Dropdown.Item>

                <Dropdown.Item
                  onClick={() => {
                    setActiveDropDown("patient_name_az");
                    onFilterSubmit({
                      sort_order: "patient_name_az",
                      page_no: 1,
                    });
                  }}
                  style={{
                    fontSize: "13px",
                    padding: "10px 15px",
                    borderBottom: "1px solid #0000001A",
                  }}
                >
                  <i
                    className={`fa fa-check mr-3 check-icon-filter ${
                      activeDropDown === "patient_name_az" ? "activeTab" : ""
                    }`}
                  ></i>
                  Patient Name (A-Z)
                </Dropdown.Item>

                <Dropdown.Item
                  onClick={() => {
                    setActiveDropDown("patient_name_za");
                    onFilterSubmit({
                      sort_order: "patient_name_za",
                      page_no: 1,
                    });
                  }}
                  style={{
                    fontSize: "13px",
                    padding: "10px 15px",
                  }}
                >
                  <i
                    className={`fa fa-check mr-3 check-icon-filter ${
                      activeDropDown === "patient_name_za" ? "activeTab" : ""
                    }`}
                  ></i>
                  Patient Name (Z-A)
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </div>

          <div className="ml-auto filter-border mr-2">
            <Dropdown>
              <Dropdown.Toggle
                className={`${
                  appointmentDropDown?.value === "upcoming" &&
                  "appointment-dropdown-disabled"
                }`}
                style={{
                  background: "transparent",
                  border: "none",
                  margin: "0px",
                  color: "#fff",
                  borderColor: "#D6DAE5",
                  backgroundColor: "#fff",
                }}
              >
                <img src={Filter} className="mt-2" />
              </Dropdown.Toggle>

              <Dropdown.Menu className="m-0">
                <Dropdown.Item
                  onClick={() => {
                    setActivePrescriptionDropDown("all");
                    prescriptionFilter({
                      prescription_filter: "all",
                      page_no: 1,
                    });
                  }}
                  style={{
                    fontSize: "13px",
                    padding: "10px 15px",
                    borderBottom: "1px solid #0000001A",
                  }}
                >
                  <i
                    className={`fa fa-check mr-3 check-icon-filter ${
                      activePrescriptionDropDown === "all" ? "activeTab" : ""
                    }`}
                    aria-hidden="true"
                  ></i>
                  All
                </Dropdown.Item>

                <Dropdown.Item
                  style={{
                    fontSize: "13px",
                    padding: "10px 15px",
                    borderBottom: "1px solid #0000001A",
                  }}
                  onClick={() => {
                    setActivePrescriptionDropDown("shared");
                    prescriptionFilter({
                      prescription_filter: "shared",
                      page_no: 1,
                    });
                  }}
                >
                  <i
                    className={`fa fa-check mr-3 check-icon-filter ${
                      activePrescriptionDropDown === "shared" ? "activeTab" : ""
                    }`}
                  ></i>
                  Prescription Shared
                </Dropdown.Item>

                <Dropdown.Item
                  onClick={() => {
                    setActivePrescriptionDropDown("not_shared");
                    prescriptionFilter({
                      prescription_filter: "not_shared",
                      page_no: 1,
                    });
                  }}
                  style={{
                    fontSize: "13px",
                    padding: "10px 15px",
                    borderBottom: "1px solid #0000001A",
                  }}
                >
                  <i
                    className={`fa fa-check mr-3 check-icon-filter ${
                      activePrescriptionDropDown === "not_shared"
                        ? "activeTab"
                        : ""
                    }`}
                  ></i>
                  Prescription Not Shared
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </div>
          {props?.pastAppointmentData?.length > 0 && (
            <TextOnlyTooltip title={disableDownload ? "" : "Download Report"}>
              <div
                style={{ alignSelf: "center", padding: 8 }}
                className="ml-auto dropdown filter-border"
                onClick={() => (disableDownload ? "" : onClickExportCsv())}
              >
                <img
                  src={disableDownload ? DisabledDownload : Download}
                  className="transaction-filter-icon pl-1 mr-2"
                  alt="download"
                  style={{ cursor: disableDownload ? "not-allowed" : "" }}
                />
              </div>
            </TextOnlyTooltip>
          )}
          <CSVLink
            data={csvData}
            filename={`Doctor_AppointmentData_${moment(new Date()).format(
              "YYYYMMMDD_HHmm"
            )}.csv`}
            ref={csvRef}
            target="_blank"
          ></CSVLink>
        </div>
      </div>
      <div className="col-lg-7 col-md-4 col-12 consult-select only_desktop mt-3">
        <Select
          options={dropdownOptions}
          onChange={handleOnChange}
          defaultValue={appointmentDropDown}
          value={appointmentDropDown}
          components={{ DropdownIndicator }}
        />
      </div>

      {/* Mobile section */}
      <div className="mt-4 mx-1 d-xs d-sm d-md d-lg-none d-xl-none">
        <div className="col-12">
          <div className="row appointment-header">
            <div className="col-md-6 col-sm-6 main-page-header d-flex align-items-center">
              <h1 className="m-0 p-0 text-header">My Appointments</h1>
            </div>
            <div
              className="row col-md-4 col-sm-4 filter ml-auto mr-1"
              style={{ justifyContent: "flex-end" }}
            >
              <div style={{ width: "30%", textAlign: "center" }}>
                <Dropdown className="filter-border">
                  <Dropdown.Toggle
                    style={{
                      background: "transparent",
                      border: "none",
                      margin: "0px",
                      // padding: "0px",
                      fontSize: "19px",
                      color: "#fff",
                      borderColor: "#D6DAE5",
                      backgroundColor: "#fff",
                      // color: "#2F2F2F",
                    }}
                  >
                    <img src={FilterIcon} />

                    {/* <i className="fa fa-filter" aria-hidden="true"></i> */}
                  </Dropdown.Toggle>

                  <Dropdown.Menu className="m-0">
                    <Dropdown.Item
                      onClick={() => {
                        setActiveDropDown("most_recent_first");
                        onFilterSubmit({
                          sort_order: "most_recent_first",
                          page_no: 1,
                        });
                      }}
                      style={{
                        fontSize: "13px",
                        padding: "10px 15px",
                        borderBottom: "1px solid #0000001A",
                      }}
                    >
                      <i
                        className={`fa fa-check mr-3 check-icon-filter ${
                          activeDropDown === "most_recent_first"
                            ? "activeTab"
                            : ""
                        }`}
                        aria-hidden="true"
                      ></i>
                      Most Recent First
                    </Dropdown.Item>

                    <Dropdown.Item
                      style={{
                        fontSize: "13px",
                        padding: "10px 15px",
                        borderBottom: "1px solid #0000001A",
                      }}
                      onClick={() => {
                        setActiveDropDown("least_recent_first");
                        onFilterSubmit({
                          sort_order: "least_recent_first",
                          page_no: 1,
                        });
                      }}
                    >
                      <i
                        className={`fa fa-check mr-3 check-icon-filter ${
                          activeDropDown === "least_recent_first"
                            ? "activeTab"
                            : ""
                        }`}
                      ></i>
                      Least Recent First
                    </Dropdown.Item>

                    <Dropdown.Item
                      onClick={() => {
                        setActiveDropDown("patient_name_az");
                        onFilterSubmit({
                          sort_order: "patient_name_az",
                          page_no: 1,
                        });
                      }}
                      style={{
                        fontSize: "13px",
                        padding: "10px 15px",
                        borderBottom: "1px solid #0000001A",
                      }}
                    >
                      <i
                        className={`fa fa-check mr-3 check-icon-filter ${
                          activeDropDown === "patient_name_az"
                            ? "activeTab"
                            : ""
                        }`}
                      ></i>
                      Patient Name (A-Z)
                    </Dropdown.Item>

                    <Dropdown.Item
                      onClick={() => {
                        setActiveDropDown("patient_name_za");
                        onFilterSubmit({
                          sort_order: "patient_name_za",
                          page_no: 1,
                        });
                      }}
                      style={{
                        fontSize: "13px",
                        padding: "10px 15px",
                      }}
                    >
                      <i
                        className={`fa fa-check mr-3 check-icon-filter ${
                          activeDropDown === "patient_name_za"
                            ? "activeTab"
                            : ""
                        }`}
                      ></i>
                      Patient Name (Z-A)
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </div>
              <div style={{ width: "30%", textAlign: "center" }}>
                <div className="ml-1">
                  <Dropdown
                    className="filter-border"
                    onClick={() => setShowFilterComponent(true)}
                  >
                    {(mobileFilterData &&
                      JSON.stringify(mobileFilterData) !== "{}") ||
                    (term?.start_date && term?.end_date) ? (
                      <div className="filterStyle"></div>
                    ) : null}
                    <Dropdown.Toggle
                      className={"appointment-filter"}
                      style={{
                        background: "transparent",
                        border: "none",
                        margin: "0px",
                        fontSize: "19px",
                        color: "#fff",
                        borderColor: "#D6DAE5",
                        backgroundColor: "#fff",
                        // color: "#2F2F2F",
                      }}
                    >
                      <img src={Filter} />
                    </Dropdown.Toggle>
                  </Dropdown>
                </div>
              </div>
              {props?.pastAppointmentData?.length > 0 && (
                <div style={{ width: "30%", textAlign: "center" }}>
                  <div className="ml-1">
                    <div className="dropdown filter-border">
                      <button
                        aria-haspopup="true"
                        aria-expanded="false"
                        type="button"
                        class="appointment-filter dropdown-toggle btn btn-primary"
                        style={{
                          background: "transparent",
                          border: "none",
                          margin: "0px",
                          fontSize: "19px",
                          color: "#fff",
                          borderColor: "#D6DAE5",
                          backgroundColor: "#fff",
                        }}
                        onClick={() =>
                          disableDownload ? "" : onClickExportCsv()
                        }
                      >
                        <img
                          src={disableDownload ? DisabledDownload : Download}
                          className="transaction-filter-icon mr-1"
                          alt="download"
                          style={{
                            cursor: disableDownload ? "not-allowed" : "",
                          }}
                        />
                      </button>
                    </div>
                  </div>
                </div>
              )}
              {/* </div> */}
              {/* <div
            class="dropdown mr-2"
            data-tooltip="Reset all"
            data-tooltip-conf="bottom"
          >
            <button
              class="btn btn-outline-secondary"
              type="button"
              onClick={() => resetClick(defaultSetUp)}
            >
              <i className="fa fa-refresh" aria-hidden="true"></i>
            </button>
          </div> */}
            </div>
          </div>
          <div>
            {is_staff === "staff" ? (
              ""
            ) : (
              <AppointmentSummary
                upcomingAppointmentCount={props.upcomingAppointmentCount}
                totalRecords={props.totalRecords}
              />
            )}
          </div>
        </div>
        <div className="col-md-12 mt-3">
          <div className="search-wrapper">
            <div className="input-holder">
              <input
                type="text"
                className="search-input"
                onChange={(e) => onSubmit({ search_string: e.target.value })}
                value={inputText}
                placeholder="Search by patient name or mobile number."
              />{" "}
              <div className="search-icon">
                <img src={searchIcon} />
              </div>
              {inputText !== "" && (
                <div className="close_serch">
                  <img src={closeIcon} onClick={clearData} />
                </div>
              )}
            </div>
          </div>
        </div>
        <div className="col-md-12 consult-select mt-3 only_mobile">
          <Select
            className="select-field"
            options={dropdownOptions}
            onChange={handleOnChange}
            defaultValue={appointmentDropDown}
            value={appointmentDropDown}
            components={{ DropdownIndicator }}
          />
        </div>
      </div>
      {/* ,....? */}

      {/* <ViewDetailsModal
        openView={openView}
        closeView={closeView}
        appointment_id={appointment_id}
      /> */}

      {showFilterComponent && (
        <FilterModal
          appointmentStatus={appointmentStatusData}
          status={status}
          doctorsRelatedDataStatus={allDoctorsRelatedData}
          onFilterSuccess={onFilterSuccess}
          prescriptionStatus={prescriptionStatus}
          show={showFilterComponent}
          handleClose={() => setShowFilterComponent(false)}
          date={dateStatus}
          start={selectedStartDate}
          end={selectedEndDate}
          mobileFilterData={mobileFilterData}
          onResetAllCall={() => {
            setShowFilterComponent(false);
            resetClick(defaultSetUp);
          }}
          selectedAppointmentType={appointmentDropDown}
          temp_doctor_selected={props.temp_doctor_selected}
          doctorFilterList={props.doctorFilterList}
          doctor_selected={props.doctor_selected}
          onlyDoctorName={onlyDoctorName}
        />
      )}

      <div className="bg-grey">
        <AppointmentHistoryList
          pastAppointmentData={props.pastAppointmentData}
          viewAppointment={viewAppointment}
          fetchPastAppointmentDataList={fetchPastAppointment}
          doctorsRelatedDataStatus={doctorsRelatedDataStatus}
          consultationStatus={consultationStatus}
          currentStatus={appointmentStatus}
          fetchCurrentFilterDates={fetchCurrentFilterDates}
          fetchCurrentFilterMarkCheckInDates={
            fetchCurrentFilterMarkCheckInDates
          }
          resetClick={() => resetClick(defaultSetUp)}
          slugUrl={props.slugUrl}
          term={term}
          mobileFilter={mobileFilter}
          mobileFilterData={mobileFilterData}
          prescriptionFilter={prescriptionFilter}
          selectedAppointmentType={appointmentDropDown}
          resetMobileFilter={resetMobileFilter}
          currentPage={currentPage}
          fetchPastAppointmentDatasAgain={props.fetchPastAppointmentDatasAgain}
          temp_doctor_selected={props.temp_doctor_selected}
          doctorFilterList={props.doctorFilterList}
          doctor_selected={props.doctor_selected}
          setDoctorSelected={props.setDoctorSelected}
          setTempDoctorSelected={props.setTempDoctorSelected}
        />

        {props.pastAppointmentData?.length > 0 ? (
          <div className="container-fluid mb-3 mt-4 bg-grey">
            <Pagination
              className="d-flex justify-content-end"
              currentPage={currentPage}
              totalCount={props.totalRecords}
              pageSize={PageSize}
              onPageChange={(page) => {
                setCurrentPage(page);
                history.replace(`/doctor/account/appointmenthistory/${page}`);
                onFilterSubmit({ page_no: page });
              }}
            />
          </div>
        ) : null}
      </div>

      <ViewDetailsModalNew
        openView={openView}
        closeView={closeView}
        appointment_id={appointment_id}
        appointmentStatus={appointment_status}
      />
    </>
  );
};

export default AppointmentHistoryLayout;
